import React from "react";
import { Link } from "react-router-dom";

export default function LogoContainer() {
  return (
    <Link to="/">
      <div className="logoContainer">
        <img src="/KarnovLogo.svg" className="App-logo" alt="logo" />
      </div>
    </Link>
  );
}
